<div class="text-center mb-3" *ngIf="loading && showLoading">
  <span class="spinner-border"></span>
</div>
<iframe *ngIf="trustUrl" [src]="trustUrl" frameborder="0" width="100%" id="iframe-print"
  [style]="{'min-height': minHeight}">
</iframe>
